import { user } from './user';
import { AppComponent } from './app.component';
import { Injectable , OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/auth';
import { auth } from 'firebase/app';

declare const gapi: any;

@Injectable({
  providedIn: 'root'
})
export class UserServiceService  {
  
  constructor(
    private http: HttpClient,
    public afAuth: AngularFireAuth,

  ) {}
  
 
  login() {
    

  }
 
  getName = () => {
    try {
   return gapi.auth2.getAuthInstance().currentUser.get().getBasicProfile().getName();
    } catch (error){
      //console.log(error);
      return "Dummy";
    }
  }
  
  logout(){
    var auth2 = gapi.auth2.getAuthInstance();
    auth2.signOut().then(function () {
      console.log('User signed out.');
    });
  }
  getImage(){  
    try {  
    return  gapi.auth2.getAuthInstance().currentUser.get().getBasicProfile().getImageUrl();
  } catch (error){
    //console.log(error);
    return "https://www.w3schools.com/w3images/avatar3.png";
  }
  }

  getUid(){
    // Google UID
    return this.afAuth.auth.currentUser.providerData[0].uid
  }

  getMCRecord(){
    //return this.http.get('/assets/record.json')
    return this.http.get('https://api.studydse.net/api/get_mc_record.php',{withCredentials: true});  
  }
  getMCStat(){

   // return this.http.get('/assets/stat.json')
    return this.http.get('https://api.studydse.net/api/get_mc_stat.php',{withCredentials: true});  
  }

  
}
